import { atom } from 'recoil';

export const isEditRouteFilterModalOpenAtom = atom<boolean>({
  key: 'isEditRouteFilterModalOpenState',
  default: false,
});
